import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Case } from '../_types/case';
import { Filter, FilterOperation, HasFilter, NotFilter, NotHasFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import { CasesService } from '../_services/cases.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { DialogService } from 'primeng/dynamicdialog';
import { CasesDetailGeneralComponent } from '../cases-detail/general/general.component';
import { CasesStatesService } from '../_services/cases-states.service';
import { CaseState } from '../_types/case-state';
import { LocalStorageService, SessionStorageService } from 'angular-web-storage';
import { toDate } from '@rxweb/reactive-form-validators';
import { CompaniesService } from '../../companies/_services/companies.service';
import { Company } from '../../companies/_types/company';
import { UsersService } from '../../users/_services/users.service';
import { CaseType } from '../../cases-types/_types/case-type';
import { CasesTypesService } from '../../cases-types/_services/cases-types.service';
import { User } from '../../users/_types/user';
import { DateUtilsService } from 'src/app/core/services/date-utils.service';
import { ServicesTypesService } from '../../services-types/_services/services-types.service';
import { CasesTreatmentsService } from '../_services/cases-treatments.service';
import { CaseTreatment } from '../_types/case-treatment';
import { Contract } from '../../companies/_types/contract';
import { ContractsService } from '../../companies/_services/contracts.service';
import { LoginService } from '../../login/login.service';
import { ContractProcessorsService } from '../../companies/_services/contracts-processors.service';
import { CasesExpertsService } from '../_services/cases-experts.service';
import { CaseService } from '../_types/case-service';
import { CapabilitiesService } from '../../common/_services/capabilities.service';
import { CountriesRegionsService } from '../../common/_services/countries-regions.service';
import { InsuranceCompaniesService } from '../../insurance-companies/_services/insurance-companies.service';
import { InsuranceCompany } from '../../insurance-companies/_types/insurance-company';
import { CasesModesService } from '../_services/cases-modes.service';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';

type FilterOption = { label: string; value: any };

//una opción de cambio masivo de estado del menú de acciones masivas
interface MassiveStateTransition {
  label: string;
  toStateCode: string;
  //null = se puede desde cualquier estado; si tiene valor, todos los seleccionados deben estar en él
  fromStateCode: string | null;
  //nombre del estado de origen tal y como se le muestra al usuario en el aviso
  fromStateName: string;
}

@Component({
    selector: 'app-cases-list',
    templateUrl: './cases-list.component.html',
    styleUrls: ['./cases-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'list-page' },
    standalone: false
})
export class CasesListComponent implements OnInit {
  public cases: Case[] = [];
  public casesStates: CaseState[] = [];
  public casesTypes: CaseType[] = [];
  public companies: Company[] = [];
  public contracts: Array<Contract> = new Array<Contract>();
  public servicesTypes: any[] = [];
  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public defaultCasesSort: string[] = ['lastActionDate', 'createdAt'];
  public filters: any = {
    caseNumber: new Filter(FilterOperation.contains, 'caseNumber'),
    companyId: new Filter(FilterOperation.any, 'companyId'),
    contractId: new Filter(FilterOperation.any, 'contractId'),
    clientName: new Filter(FilterOperation.contains, 'client.name'),
    clientPolicy: new Filter(FilterOperation.contains, 'clientPolicy.policyNumber'),
    insuranceCompanyId: new Filter(FilterOperation.equals, 'clientPolicy.insuranceCompanyId'),
    caseStateId: new Filter(FilterOperation.any, 'caseStateId'),
    caseNotStateFinal: new NotFilter(FilterOperation.equals, 'caseState.isFinal', '', null, true),
    caseTypeId: new Filter(FilterOperation.equals, 'caseTypeId'),
    //processorId: new Filter(FilterOperation.any, 'processorId'),
    processorId: new OrFilter([
      new Filter(FilterOperation.any, 'processorId'),
      new Filter(FilterOperation.equals, 'processorId', '', null, false)
    ]),
     //withoutProcessorId: new Filter(FilterOperation.equals, 'processorId'),
    isUrgent: new Filter(FilterOperation.equals, 'isUrgent', '', null,true),
    isPrecite: new Filter(FilterOperation.equals, 'isPrecite', '', null,true),
    withoutCompany: new OrFilter([
      new Filter(FilterOperation.equals, 'companyId', '', null, false),
      new Filter(FilterOperation.equals, 'contractId', '', null, false)
    ]),
    serviceTypeId: new HasFilter('caseServiceTypes', new Filter(FilterOperation.equals, 'serviceTypeId')),
    caseTreatmentId: new Filter(FilterOperation.equals, 'caseTreatmentId'),
    isRecapture: new Filter(FilterOperation.equals, 'isRecapture', '', null, false),
    //transactionDeleted: new HasFilter('transactions', new Filter(FilterOperation.equals, 'deleted', '', false)),
    notificationNumber: new HasFilter('caseNotificationNumbers', new Filter(FilterOperation.contains, 'code')),
    revisionDateFrom: new Filter(FilterOperation.greaterOrEqual, 'revisionDate'),
    revisionDateTo: new Filter(FilterOperation.lessThan, 'revisionDate'),
    clientphone:new OrFilter([
       new Filter(FilterOperation.contains, 'client.phone1'),
       new Filter(FilterOperation.contains, 'client.phone2'),
       new Filter(FilterOperation.contains, 'client.phone3')
    ]),
    clientEmail: new Filter(FilterOperation.contains, 'client.email'),
    caseAddress: new Filter(FilterOperation.contains, 'address.addressLine1'),
    caseZity: new Filter(FilterOperation.contains, 'address.city'),
    caseZipCode: new Filter(FilterOperation.contains, 'address.zipCode'),
    technicianId: new HasFilter('caseUsers', new Filter(FilterOperation.any, 'userId')),
    pendingCapabilityId: new Filter(FilterOperation.equals, 'pendingCapabilityId'),
    countryRegionId: new Filter(FilterOperation.equals, 'address.countryRegionId'),    
    caseServicesId: new NotHasFilter('caseServices'),

    caseModeId: new Filter(FilterOperation.any, 'caseModeId')
  };
  public withoutCompanyFlag: Filter = new Filter(FilterOperation.equals);
  public withoutProcessorFlag: Filter = new Filter(FilterOperation.equals);

  public stateOptions: FilterOption[] = [];
  public companyOptions: FilterOption[] = [];
  public contractOptions: FilterOption[] = [];
  public caseModeOptions: FilterOption[] = [];
  public caseTypeOptions: FilterOption[] = [];
  public processorOptions: FilterOption[] = [];
  public technicianOptions: FilterOption[] = [];
  public serviceTypeOptions: FilterOption[] = [];
  public treatmentOptions: FilterOption[] = [];
  public insuranceCompanyOptions: FilterOption[] = [];
  public regionOptions: FilterOption[] = [];
  public capabilityOptions: FilterOption[] = [];
  private lastCompanySignature: string = 'null';

  public quickSearchField: Filter = this.filters.caseNumber;

  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.caseStateId, type: 'multiselect', label: 'Estado', options: this.stateOptions, base: true },
    { filter: this.filters.processorId.filters[0], type: 'multiselect', label: 'Tramitador', options: this.processorOptions, base: true },
    { filter: this.filters.companyId, type: 'multiselect', label: 'Compañía', options: this.companyOptions, base: true },
    { filter: this.filters.caseNotStateFinal, type: 'bool', label: 'Sólo activos', base: true },
    { filter: this.filters.contractId, type: 'multiselect', label: 'Contrato', options: this.contractOptions },
    { filter: this.filters.caseModeId, type: 'multiselect', label: 'Tipo', options: this.caseModeOptions },
    { filter: this.filters.caseTypeId, type: 'select', label: 'Tipo de daño', options: this.caseTypeOptions, filterable: true },
    { filter: this.filters.technicianId.filter, type: 'multiselect', label: 'Técnico', options: this.technicianOptions },
    { filter: this.filters.notificationNumber.filter, type: 'text', label: 'Nº servicio' },
    { filter: this.filters.serviceTypeId.filter, type: 'select', label: 'Tipo de servicio', options: this.serviceTypeOptions, filterable: true },
    { filter: this.filters.caseTreatmentId, type: 'select', label: 'Tratamiento', options: this.treatmentOptions },
    { filter: this.filters.isRecapture, type: 'select', label: 'Reapertura', options: [{ label: 'Sí', value: true }, { label: 'No', value: false }] },
    { filter: this.filters.revisionDateFrom, filterTo: this.filters.revisionDateTo, type: 'date', label: 'Revisión' },
    { filter: this.filters.clientPolicy, type: 'text', label: 'Nº póliza' },
    { filter: this.filters.insuranceCompanyId, type: 'select', label: 'Compañía aseguradora', options: this.insuranceCompanyOptions, filterable: true },
    { filter: this.filters.clientName, type: 'text', label: 'Asegurado' },
    { filter: this.filters.clientphone.filters[0], type: 'text', label: 'Teléfono' },
    { filter: this.filters.clientEmail, type: 'text', label: 'Email' },
    { filter: this.filters.caseAddress, type: 'text', label: 'Dirección' },
    { filter: this.filters.caseZity, type: 'text', label: 'Ciudad' },
    { filter: this.filters.caseZipCode, type: 'text', label: 'Código postal' },
    { filter: this.filters.countryRegionId, type: 'select', label: 'Provincia', options: this.regionOptions, filterable: true },
    { filter: this.filters.pendingCapabilityId, type: 'select', label: 'Gremio pendiente', options: this.capabilityOptions, filterable: true },
    { filter: this.filters.isUrgent, type: 'bool', label: 'Urgentes' },
    { filter: this.withoutCompanyFlag, type: 'bool', label: 'Sin compañía' },
    { filter: this.withoutProcessorFlag, type: 'bool', label: 'Sin tramitador' },
    { filter: this.filters.isPrecite, type: 'bool', label: 'Precita' },
    { filter: this.filters.caseServicesId, type: 'bool', label: 'Sin citas' }
  ];

  public allowDelete: boolean = false;
  public selectedCase?: Case;
  public selectedCases: any[] = [];
  public displayProcessorModal: boolean = false;
  public processorId: string = "";
  public processors: User[] = [];
  public technicians: User[] = [];
  public casesTreatments: CaseTreatment[] = [];
  public isRecaptureOptions: any[] = [
    { label: 'Todos', value: null },
    { label: 'No', value: false },
    { label: 'Sí', value: true },
  ];
  public allowAssignProcessor: boolean = false;
  public allowMassiveStateChange: boolean = false;
  // Espejo de MassiveStateTransitions del backend: habilitar una transición nueva es añadir una entrada aquí
  // y otra allí. fromStateCode a null = se puede desde cualquier estado.
  public massiveStateTransitions: MassiveStateTransition[] = [
    { label: 'Cambiar a Pendiente de tramitar', toStateCode: 'TRAMITATION_PENDING', fromStateCode: 'ASSIGNMENT_PENDING', fromStateName: 'Pendiente asignaciones' }
  ];
  public casesExpertsList: any[]= [];
  public capabilities: any[] = [];
  public countriesRegions: any[] = [];

  public insuranceCompanies: InsuranceCompany[] = [];
  private hasQueryParamsFilters: boolean = false;
  public caseModes: any[] = [];

  constructor(
    private casesService: CasesService,
    private topbarService: TopbarService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private dialogService: DialogService,
    private storage: LocalStorageService,
    private sessionStorage: SessionStorageService,
    private casesStatesService: CasesStatesService,
    private casesTypesService: CasesTypesService,
    private companiesService: CompaniesService,
    private usersService: UsersService,
    private dateUtilsService: DateUtilsService,
    private servicesTypesService: ServicesTypesService,
    private casestreatmentsService: CasesTreatmentsService,
    private contractsService: ContractsService,
    private loginService: LoginService,
    private contractProcessorsService: ContractProcessorsService,
    private casesExpertsService: CasesExpertsService,
    private capabilitiesService: CapabilitiesService,
    private countriesRegionsService: CountriesRegionsService,
    private insuranceCompaniesService: InsuranceCompaniesService,
    private caseModeService: CasesModesService

  ) {
    
    this.allowDelete = this.loginService.hasPermission("CASES.DELETE");
    this.allowAssignProcessor =  this.loginService.hasPermission("CASES.ASSIGN_PROCESSOR");
    this.allowMassiveStateChange = this.loginService.hasPermission("CASES.MASSIVE_STATE_CHANGE");
    
    this.filters.clientName.value = this.route.snapshot.queryParamMap.get('clientName');
    this.filters.clientPolicy.value = this.route.snapshot.queryParamMap.get('clientPolicy');
    //lo usa la banda de expedientes relacionados del detalle cuando el criterio es asegurado + dirección
    this.filters.caseAddress.value = this.route.snapshot.queryParamMap.get('caseAddress');
   // this.filters.notificationNumber.value = this.route.snapshot.queryParamMap.get('notificationNumber');
    this.filters.withoutCompany.filters[0].allowNull = this.route.snapshot.queryParamMap.get('withoutCompany') === 'true';
    this.filters.withoutCompany.filters[1].allowNull = this.route.snapshot.queryParamMap.get('withoutCompany') === 'true';
    
    if(this.route.snapshot.queryParamMap.get('clientName')) this.hasQueryParamsFilters = true;
    if(this.route.snapshot.queryParamMap.get('clientPolicy')) this.hasQueryParamsFilters = true;
    if(this.route.snapshot.queryParamMap.get('caseAddress')) this.hasQueryParamsFilters = true;
    if(this.route.snapshot.queryParamMap.get('processorId')) this.hasQueryParamsFilters = true;
    if(this.route.snapshot.queryParamMap.get('revisionDateFrom')) this.hasQueryParamsFilters = true;
    if(this.route.snapshot.queryParamMap.get('revisionDateTo')) this.hasQueryParamsFilters = true;
    if(this.route.snapshot.queryParamMap.get('withoutCompany') === 'true') this.hasQueryParamsFilters = true;
    if(this.route.snapshot.queryParamMap.get('withoutProcessor') === 'true'){
      //this.filters.processorId.value = '00000000-0000-0000-0000-000000000000';
      //this.filters.processorId.allowNull = true;
      this.filters.processorId.filters[1].value = true;
      this.filters.processorId.filters[1].allowNull = true;

      this.filters.caseNotStateFinal.value = null;
      this.hasQueryParamsFilters = true;
    }
    
    if(this.route.snapshot.queryParamMap.get('noServices') === 'true') {
      this.hasQueryParamsFilters = true;
      this.filters.caseServicesId.value = true;
    }

    this.withoutCompanyFlag.value = this.filters.withoutCompany.filters[0].allowNull === true ? true : null;
    this.withoutProcessorFlag.value = this.filters.processorId.filters[1].allowNull === true ? true : null;
  }

 ngOnInit(): void  {
    this.topbarService.setTitle("Expedientes");

    this.route.paramMap.subscribe((params: ParamMap) => {
      //cada opción depende de su propio permiso
      let menuItems: MenuItem[] = [];
      if (this.allowAssignProcessor) {
        menuItems.push({ label: 'Asignar tramitador', icon: 'pi pi-user', command: () => this.assignProcessor() });
      }
      if (this.allowMassiveStateChange) {
        for (let transition of this.massiveStateTransitions) {
          menuItems.push({ label: transition.label, icon: 'pi pi-directions', command: () => this.changeCasesState(transition) });
        }
      }
      //el menú solo se pone si le queda alguna opción. La función de acción no se usa: cuando hay menuItems
      //el topbar despliega el menú en lugar de invocarla.
      if (menuItems.length > 0) {
        this.topbarService.addAction("Acciones masivas", "pi pi-ellipsis-v", false, () => { }, menuItems);
      }
      this.topbarService.addAction("Nuevo", "pi pi-plus", false, () => {
        this.edit({} as Case);
      });

    });

    //recuperar filtros guardados
    let savedFilters = this.sessionStorage.get("casesFilters");
    if (savedFilters != null && !this.hasQueryParamsFilters) FilterBuilder.loadSavedFilters(this.filters, savedFilters);
    if(this.filters.revisionDateFrom.value) this.filters.revisionDateFrom.value = new Date(this.filters.revisionDateFrom.value);
    if(this.filters.revisionDateTo.value) this.filters.revisionDateTo.value = new Date(this.filters.revisionDateTo.value);
    
    this.filters.caseNotStateFinal.value = true;

    //guarecuperar orden guardados
    let savedOrder = this.sessionStorage.get("casesOrder");
    if(savedOrder != null) this.defaultCasesSort = savedOrder;

    //si recibimos filtro de revisión desde en query param
    if(this.route.snapshot.queryParamMap.get('revisionDateFrom')) this.filters.revisionDateFrom.value = new Date(this.route.snapshot.queryParamMap.get('revisionDateFrom') as string);

    //si recibimos filtro de revisión hasta en query param
    if(this.route.snapshot.queryParamMap.get('revisionDateTo')) this.filters.revisionDateTo.value = new Date(this.route.snapshot.queryParamMap.get('revisionDateTo') as string);
    //si recibimos filtro de tramitador en query param
    if(this.route.snapshot.queryParamMap.get('processorId')) {
      this.filters.processorId.filters[0].value = [this.route.snapshot.queryParamMap.get('processorId')];
    }
    //si recibimos filtro de witoutProccesor quitamos el caseNotStateFinal porque es lo que muestra en el dashboard
    if(this.route.snapshot.queryParamMap.get('withoutProcessor') === 'true') this.filters.caseNotStateFinal.value = null;

    
    this.loadCaseStates();
    this.loadCompanies();
    this.loadProcessors();
    this.loadTechnicians();
    this.loadCaseTypes();
    this.loadServicesTypes();
    this.loadCasesTreatments();    
    this.loadCapabilities();
    this.loadCountriesRegions();
    this.loadInsuranceCompanies();
    this.loadCaseModes();
    this.refreshContracts();
  }

  async loadCapabilities() {
    let response = await firstValueFrom(this.capabilitiesService.all());
    this.capabilities = response.data;
    this.fillOptions(this.capabilityOptions, response.data);
  }
   async loadCountriesRegions() {
    let response = await firstValueFrom(this.countriesRegionsService.all());
    this.countriesRegions = response.data;
    this.fillOptions(this.regionOptions, response.data);
  }

  getSortField():string{
    let field = "";
    if(this.defaultCasesSort.length > 0){
      field = this.defaultCasesSort[0].replace("-", "");
    }
    return field;
  }
  getSortOrder():number{
    let order = 1;
    if(this.defaultCasesSort.length > 0){
      order = this.defaultCasesSort[0].indexOf("-") === 0 ? -1 : 1;
    }
    return order;
  }

  async loadCaseStates() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 }
    }
    let response = await firstValueFrom(this.casesStatesService.all(params));
    this.casesStates = response.data;
    this.fillOptions(this.stateOptions, response.data);
  }

  async loadCaseTypes() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 }
    };
    let response = await firstValueFrom(this.casesTypesService.all(params));
    let undefinedType:CaseType = new CaseType();
    undefinedType.id = '00000000-0000-0000-0000-000000000000';
    undefinedType.name = "Sin definir";
    let items:CaseType[] = [undefinedType];
    items = items.concat(response.data);
    this.casesTypes = items;
    this.fillOptions(this.caseTypeOptions, items);
  }

  async loadServicesTypes() {
    let params: IParamsCollection = {}
    let response = await firstValueFrom(this.servicesTypesService.all(params));
    this.servicesTypes = response.data;
    this.fillOptions(this.serviceTypeOptions, response.data);
  }

  async loadCompanies() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 }
    };
    let response = await firstValueFrom(this.companiesService.all(params));
    this.companies = response.data;
    this.fillOptions(this.companyOptions, response.data);
  }
  async loadCasesTreatments() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 1000 }
    };
    let response = await firstValueFrom(this.casestreatmentsService.all(params));
    this.casesTreatments = response.data;
    this.fillOptions(this.treatmentOptions, response.data);
  }
  async loadInsuranceCompanies() {
    let response = await firstValueFrom(this.insuranceCompaniesService.all({ sort: ['name'], page: { number: 1, size: 200 }}));
    this.insuranceCompanies = response.data;
    this.fillOptions(this.insuranceCompanyOptions, response.data);
  }
  async loadCaseModes(){
    let params: IParamsCollection = {
      sort: ['name']
    };
    let response = await firstValueFrom(this.caseModeService.all(params));
    this.caseModes = response.data;
    this.fillOptions(this.caseModeOptions, response.data);
    
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first + 1, size: $event.rows },
      sort: this.defaultCasesSort,
      include: ['client', 'processor', 'address', 'caseState', 'caseType', 'contract', 'caseTreatment', 'caseServiceTypes.serviceType'],
      fields: {
        cases: 'id,caseNumber,caseDate,revisionDate,lastActionDate,expertStatus,isRecapture,isVIP,isUrgent,isPrecite,incidentsStatus,caseType,caseState,contractId,contract,client,address,caseTreatment,processor,caseServiceTypes,companyWorkInProgress,budgetsStatus,invoicesStatus,recaptureDate',
        caseStates: 'id,name,backgroundColor,foregroundColor',
        caseTypes: 'id,name',
        caseTreatments: 'id,name,icon,backgroundColor',
        clients: 'id,name,phone1,phone2',
        //addressLine1/zipCode/city/countryCode alimentan fullAddress, que se calcula en el servidor
        addresses: 'id,addressLine1,zipCode,city,countryCode,fullAddress',
        users: 'id,name,absence',
        contracts: 'id,code',
        caseServiceTypes: 'id,serviceType',
        serviceTypes: 'id,name'
      }
    }

    if ($event.sortField && $event.sortField !== 'firstServiceTypeName' && $event.sortField !== 'caseExperts' && $event.sortField !== 'budgetOrder') {
      params.sort = [($event.sortOrder > 0 ? '' : '-') + $event.sortField];
    }

    if (this.filters.clientPolicy.value == '') this.filters.clientPolicy.value = null;
    if (this.filters.contractId.value == '') this.filters.contractId.value = null;
    if (this.filters.companyId.value == '') this.filters.companyId.value = null;
    //if (this.filters.processorId.value == '') this.filters.processorId.value = null;
    if (this.filters.technicianId.filter.value == '') this.filters.technicianId.filter.value = null;
    if (this.filters.caseStateId.value == '') this.filters.caseStateId.value = null;
    if (this.filters.caseModeId.value == '') this.filters.caseModeId.value = null;

    //guardamos los filtros en la sesion
    this.sessionStorage.set("casesFilters", this.filters);

    //guardamos el orden en la sesion
    this.sessionStorage.set("casesOrder", params.sort);

    //si es casetype 00000000-0000-0000-0000-000000000000, lo quitamos
    let resetCaseTypeFilter = false;
    if(this.filters.caseTypeId.value === '00000000-0000-0000-0000-000000000000'){
      resetCaseTypeFilter = true;
      this.filters.caseTypeId.allowNull = true;
      this.filters.caseTypeId.value = null;
    }

    //si es processior 00000000-0000-0000-0000-000000000000, lo quitamos
    let resetProcesorFilter = false;
   /* if(this.filters.processorId.value === '00000000-0000-0000-0000-000000000000'){
      resetProcesorFilter = true;
      this.filters.processorId.allowNull = true;
      this.filters.processorId.value = null;
    }*/
    this.filters.withoutCompany.filters[0].allowNull = this.withoutCompanyFlag.value === true;
    this.filters.withoutCompany.filters[1].allowNull = this.withoutCompanyFlag.value === true;
    this.filters.processorId.filters[1].value = null;
    this.filters.processorId.filters[1].allowNull = this.withoutProcessorFlag.value === true;

    for (let key of ['isUrgent', 'isPrecite', 'caseNotStateFinal']) {
      this.filters[key].value = this.filters[key].value === true ? true : null;
      this.filters[key].allowNull = false;
    }

    this.filters.clientphone.filters[0].value = this.filters.clientphone.filters[0].value;
    this.filters.clientphone.filters[1].value = this.filters.clientphone.filters[0].value;
    this.filters.clientphone.filters[2].value = this.filters.clientphone.filters[0].value;

    console.log(this.filters);
    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();
    let user = this.storage.get("user");

    ///resetamos filtro de tipo de caso si es el valor por defecto
    if(resetCaseTypeFilter){
      this.filters.caseTypeId.value = '00000000-0000-0000-0000-000000000000';
      this.filters.caseTypeId.allowNull = false;
    }

    ///resetamos filtro de tramitador si es el valor por defecto
    /*if(resetProcesorFilter){
      this.filters.processorId.value = '00000000-0000-0000-0000-000000000000';
      this.filters.processorId.allowNull = false;
    }*/

    //let response = await firstValueFrom(this.casesService.getAll(user.id, params));
    let response = await firstValueFrom(this.casesService.all(params));

    //lista de peritos
    var listCasesIds = response.data.filter(m => m.expertStatus != null).map(m => m.id);
    if(listCasesIds.length > 0){
      await this.getExpert(listCasesIds);
    }
    

    this.cases = response.data.map(c => {
      const firstName = c.caseServiceTypes?.[0]?.serviceType?.name ?? '';
      const filteredTransactions = (c.transactions || []).filter((t: any) => !t.deleted);

      let budgetOrder = 3;
      const budgets = (c.transactions || []).filter((t:any) => t.transactionType?.code === 'company_outgoing_budget' || t.transactionType?.code === 'ingoing_budget_worker' ||
        t.transactionType?.code === 'outgoing_budget' || t.transactionType?.code === 'affected_outgoing_budget');

      if (budgets.length > 0) {
        const hasPending = budgets.some((t:any) => t.transactionState.code === 'pending');
        const allAccepted = budgets.every((t:any) => t.transactionState.code === 'accepted');
        if (hasPending) budgetOrder = 1;
        else if (allAccepted) budgetOrder = 2;
      }
      
      if(c.expertStatus!="" && c.expertStatus!=null){
        c.expertTooltip = this.casesExpertsList.filter(m => m.caseId == c.id).map(m => m.expert.name).join(', '); 
      }

      return {
        ...c,
        transactions: filteredTransactions,
        firstServiceTypeName: firstName,
        budgetOrder
      };
    });

    if ($event.sortField === 'firstServiceTypeName') {
      this.cases.sort((a, b) => {
        const nameA = a.firstServiceTypeName.toLowerCase();
        const nameB = b.firstServiceTypeName.toLowerCase();
        return $event.sortOrder > 0
          ? nameA.localeCompare(nameB)
          : nameB.localeCompare(nameA);
      });
    }

    if ($event.sortField === 'caseExperts') {
      this.cases.sort((a, b) => {
        const aHas = a.caseExperts?.length > 0 ? 1 : 0;
        const bHas = b.caseExperts?.length > 0 ? 1 : 0;
        return $event.sortOrder > 0 ? aHas - bHas : bHas - aHas;
      });
    }

    if ($event.sortField === 'budgetOrder') {
      this.cases.sort((a:any, b:any) => {
        return $event.sortOrder > 0
          ? a.budgetOrder - b.budgetOrder
          : b.budgetOrder - a.budgetOrder;
      });
    }
    this.totalRecords = response.meta["total"];
    this.topbarService.setCount(this.totalRecords);
  }

  /*
  clearFilters() {
    this.filters = {};
    //this.filters.caseNotStateFinal = new NotFilter(FilterOperation.equals, 'caseState.isFinal', '', null, true);
    this.filters = {
      caseNumber: new Filter(FilterOperation.contains, 'caseNumber'),
      companyId: new Filter(FilterOperation.any, 'companyId'),
      contractId: new Filter(FilterOperation.any, 'contractId'),
      clientName: new Filter(FilterOperation.contains, 'client.name'),
      clientPolicy: new Filter(FilterOperation.contains, 'clientPolicy.policyNumber'),
      insuranceCompanyId: new Filter(FilterOperation.equals, 'clientPolicy.insuranceCompanyId'),
      caseStateId: new Filter(FilterOperation.any, 'caseStateId'),
      caseNotStateFinal: new NotFilter(FilterOperation.equals, 'caseState.isFinal', '', null, true),
      caseTypeId: new Filter(FilterOperation.equals, 'caseTypeId'),
      processorId: new OrFilter([
        new Filter(FilterOperation.any, 'processorId'),
        new Filter(FilterOperation.equals, 'processorId', '', null, false)
      ]),
      //withoutProcessorId: new Filter(FilterOperation.equals, 'processorId'),
      isUrgent: new Filter(FilterOperation.equals, 'isUrgent', '', null,true),
      isPrecite: new Filter(FilterOperation.equals, 'isPrecite', '', null,true),
      withoutCompany: new OrFilter([
        new Filter(FilterOperation.equals, 'companyId', '', null, false),
        new Filter(FilterOperation.equals, 'contractId', '', null, false)
      ]),
      serviceTypeId: new HasFilter('caseServiceTypes', new Filter(FilterOperation.equals, 'serviceTypeId')),
      caseTreatmentId: new Filter(FilterOperation.equals, 'caseTreatmentId'),
      isRecapture: new Filter(FilterOperation.equals, 'isRecapture', '', null, false),
      notificationNumber: new HasFilter('caseNotificationNumbers', new Filter(FilterOperation.contains, 'code')),
      revisionDateFrom: new Filter(FilterOperation.greaterOrEqual, 'revisionDate'),
      revisionDateTo: new Filter(FilterOperation.lessThan, 'revisionDate'),
      clientphone:new OrFilter([
         new Filter(FilterOperation.contains, 'client.phone1'),
         new Filter(FilterOperation.contains, 'client.phone2'),
         new Filter(FilterOperation.contains, 'client.phone3')
      ]),
      clientEmail: new Filter(FilterOperation.contains, 'client.email'),
      caseAddress: new Filter(FilterOperation.contains, 'address.addressLine1'),
      caseZity: new Filter(FilterOperation.contains, 'address.city'),
      caseZipCode: new Filter(FilterOperation.contains, 'address.zipCode'),
      technicianId: new HasFilter('caseUsers', new Filter(FilterOperation.any, 'userId')),
      pendingCapabilityId: new Filter(FilterOperation.equals, 'pendingCapabilityId'),
      countryRegionId: new Filter(FilterOperation.equals, 'address.countryRegionId'),
      //casesServiceId: new NotFilter(FilterOperation.any, 'casesServiceId')
      caseModeId: new Filter(FilterOperation.any, 'caseModeId'),
      caseServicesId: new NotHasFilter('caseServices'),
    };
    this.filters.caseNotStateFinal.value = true;

    this.search();
  }
  */

  async search() {
    await this.refreshContracts();
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  private async refreshContracts() {
    const signature = JSON.stringify(this.filters.companyId.value ?? null);
    if (signature === this.lastCompanySignature) return;
    this.lastCompanySignature = signature;

    let items: Contract[] = [];
    if (this.filters.companyId.value != null) {
      let params: IParamsCollection = {
        sort: ['name'],
        page: { number: 1, size: 1000 },
        filter: FilterBuilder.fromObject({ companyId: new Filter(FilterOperation.any, 'companyId', '', this.filters.companyId.value) }).build()
      };
      let response = await firstValueFrom(this.contractsService.all(params));
      items = response.data;
    }
    this.contracts = items;
    this.fillOptions(this.contractOptions, items);
  }

  private fillOptions(target: FilterOption[], items: any[]) {
    target.length = 0;
    target.push(...items.map(item => ({ label: item.name, value: item.id })));
  }

  /*
  async companyChanged() {

    if (this.filters.companyId.value != null) {
      let filters = {
        companyId: new Filter(FilterOperation.any, 'companyId', "", this.filters.companyId.value)
      };

      let params: IParamsCollection = {
        sort: ['name'],
        page: { number: 1, size: 1000 },
        filter: FilterBuilder.fromObject(filters).build()
      };

      let response = await firstValueFrom(this.contractsService.all(params));
      this.contracts = response.data;
      this.search();
    } else {
      this.contracts = [];
      this.search()
    }
  }
  
  noProcessorSelected(event: any) {
    this.filters.processorId.filters[1].value = event.checked;
    this.filters.processorId.filters[1].allowNull = event.checked;
    //this.filters.caseNotStateFinal.value = null;
    this.loadData(this.lastGridEvent);
  }

  noCompanySelected(event: any) {
    this.filters.withoutCompany.filters[0].allowNull = event.checked;
    this.filters.withoutCompany.filters[1].allowNull = event.checked;
    this.loadData(this.lastGridEvent);
  }
  */

  getTimeAgo(date?: Date) {
    if(date==null) return "";
    return this.dateUtilsService.getTimeAgo(date);
  }

  edit(caseItem: Case) {
    if (Object.keys(caseItem).length > 0) {
      this.router.navigate(['cases/' + caseItem.id]);
    } else {
      let ref = this.dialogService.open(CasesDetailGeneralComponent, {
        closable: true,
        modal: true,
        header: 'Datos generales',
        width: '50%',
        data: {

        }
      });
      ref.onClose.subscribe((data: Case) => {
        if (data != null) {
          this.router.navigate(['cases/' + data.id]);
        }
      });
    }

  }

  delete(caseItem: Case) {
    if (this.allowDelete) {
      this.confirmationService.confirm({
        message: "¿Está seguro que desea eliminar el expediente?",
        header: "Eliminar expediente",
        acceptLabel: "Aceptar",
        rejectLabel: "Cancelar",
        acceptButtonStyleClass: "p-button-danger",
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.casesService.delete(caseItem.id).subscribe({
            next: (data: any) => {
              this.messageService.add({ closable: true, severity: 'success', detail: "Expediente eliminado correctamente" });
              this.loadData(this.lastGridEvent);
            },
            error: (error: any) => {
              this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
            }
          });
        },
        reject: (error: any) => {
          this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
        }
      });
    }
  }


  assignProcessor() {
    if (this.selectedCases.length > 0) {
      this.loadProcessors();
      this.displayProcessorModal = true;
    } else {
      this.messageService.add({ closable: true, severity: 'error', detail: "Debe seleccionar al menos un expediente" });
    }

  }

  async loadProcessors(event? : any) {
    let text = "";
    if (event != null) text = event.filter; 

    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 300 },
      fields: {
        users: 'id,name',
      }
    }
    //creamos filtros
    // filtrar solo técnicos
    let filters: any = {
      userType: new Filter(FilterOperation.contains, 'userType.code', '', 'processor'),
      name: new Filter(FilterOperation.contains, 'name', '', text)    
    };

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.usersService.all(params));
    /*let undefinedType:User = new User();
    undefinedType.id = '00000000-0000-0000-0000-000000000000';
    undefinedType.name = "Sin definir";
    let items:User[] = [undefinedType];
    items = items.concat(response.data);*/
    let items:User[] = response.data;

    this.processors = items;
    if (event == null) this.fillOptions(this.processorOptions, items);
    /*if(this.route.snapshot.queryParamMap.get('withoutProcessor') === 'true'){
      this.filters.processorId.value = '00000000-0000-0000-0000-000000000000';
    }*/
  }

  async loadTechnicians(event? : any) {
    let text = "";
    if (event != null) text = event.filter; 

    let params: IParamsCollection = {
      sort: ['name'],
      page: { number: 1, size: 300 },
      fields: {
        users: 'id,name',
      }
    }
    //creamos filtros
    // filtrar solo técnicos
    let filters: any = {
      userType: new Filter(FilterOperation.contains, 'userType.code', '', 'technical'),
      name: new Filter(FilterOperation.contains, 'name', '', text)    
    };

    //creamos filtros
    params.filter = FilterBuilder.fromObject(filters).build();

    let response = await firstValueFrom(this.usersService.all(params));
    this.technicians = response.data;
    this.fillOptions(this.technicianOptions, response.data);

  }

  async saveProcessor() {
    await firstValueFrom(this.casesService.updateProcessor(this.processorId!, this.selectedCases.map(m => m.id)));
    this.displayProcessorModal = false;
    this.selectedCases = [];
    this.loadData(this.lastGridEvent);
  }

  //Cambio masivo de estado. Si la transición exige un estado de origen y alguno de los seleccionados no lo
  //tiene, no se cambia ninguno: el aviso dice cuáles son y no deja confirmar.
  changeCasesState(transition: MassiveStateTransition) {
    if (this.selectedCases.length == 0) {
      this.messageService.add({ closable: true, severity: 'error', detail: "Debe seleccionar al menos un expediente" });
      return;
    }

    // Cogemos los casos que no cumplen la condición de estado de origen, si es que hay una condición.
    // Si no hay condición, todos son válidos. Si hay condición, el case seleccionado debe tener el estado de origen para poder cambiarlo.
    let invalidCases = transition.fromStateCode == null
      ? []
      : this.selectedCases.filter(m => m.caseState?.code !== transition.fromStateCode);

    if (invalidCases.length > 0) {
      let caseNumbers = invalidCases.slice(0, 10).map(m => m.caseNumber).join(", ");
      if (invalidCases.length > 10) caseNumbers += ", ...";
      this.confirmationService.confirm({
        header: transition.label,
        message: invalidCases.length + " de " + this.selectedCases.length + " expedientes seleccionados no están en estado \"" + transition.fromStateName + "\", por lo que no se puede hacer el cambio masivo: " + caseNumbers,
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Cerrar",
        rejectVisible: false,
        accept: () => { }
      });
      return;
    }

    this.confirmationService.confirm({
      header: transition.label,
      message: "¿Está seguro que desea cambiar el estado de " + this.selectedCases.length + " expediente(s)?",
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      accept: () => {
        this.casesService.updateCasesState(transition.toStateCode, this.selectedCases.map(m => m.id)).subscribe({
          next: (data: any) => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Estado cambiado en " + data.changed + " expediente(s)" });
            this.selectedCases = [];
            this.loadData(this.lastGridEvent);
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      }
    });
  }

  getRevisionDateClass(date: string | Date): string {
    const today = new Date();
    const revisionDate = new Date(date);

    const isToday =
      revisionDate.getFullYear() === today.getFullYear() &&
      revisionDate.getMonth() === today.getMonth() &&
      revisionDate.getDate() === today.getDate();

    if (revisionDate < today && !isToday) {
      return 'text-danger';
    } else if (isToday) {
      return 'text-warning';
    } else {
      return '';
    }
  }

  getBudgetTransactionStatusColor(caseItem: Case): string | null {
    let color = null;
    if (caseItem.budgetsStatus=='has_pending_budgets') color = 'bg-red-500';
    else if (caseItem.budgetsStatus=='budgets_ok') color = 'bg-green-500';
    return color;
  }


  getInvoiceTransactionStatusColor(caseItem: Case): string | null {
    let color = null;
    if (caseItem.invoicesStatus=='has_pending_invoices') color = 'bg-red-500';
    else if (caseItem.invoicesStatus=='invoices_ok') color = 'bg-green-500';
    return color;
  }

  async getExpert(casesId: any){
    let params: IParamsCollection = {
      include: ['expert']
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.any, "caseId", "", casesId),
    };
    params.filter = FilterBuilder.fromObject(filters).build();

    var response = await firstValueFrom(this.casesExpertsService.all(params));

    this.casesExpertsList = response.data;

  }

}
